import axios from 'axios';
import { serialize } from 'object-to-formdata';

export default (id, data, params) =>
  axios.post(`/v1/announcements/${id}`, serialize(data), { params }).then(({ data }) => data);
